module.exports = __webpack_public_path__ + "img/affiliate.d1cde749.svg";